var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadlock96(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3334 36.5625V22.5C30.3334 14.2157 37.1237 7.5 45.5 7.5C53.8763 7.5 60.6667 14.2157 60.6667 22.5V36.5625H30.3334ZM62.5625 22.5C62.5625 13.1802 54.9234 5.625 45.5 5.625C36.0767 5.625 28.4375 13.1802 28.4375 22.5V36.5625H15.1667C12.0256 36.5625 9.47919 39.0809 9.47919 42.1875V78.75C9.47919 81.8566 12.0256 84.375 15.1667 84.375H75.8334C78.9745 84.375 81.5209 81.8566 81.5209 78.75V42.1875C81.5209 39.0809 78.9745 36.5625 75.8334 36.5625H62.5625V22.5ZM79.625 78.75C79.625 80.8211 77.9274 82.5 75.8334 82.5H15.1667C13.0726 82.5 11.375 80.8211 11.375 78.75V42.1875C11.375 40.1164 13.0726 38.4375 15.1667 38.4375H75.8334C77.9274 38.4375 79.625 40.1164 79.625 42.1875V78.75Z",
    fill: "#1D2329"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4479 61.7442V67.5005H44.5521V61.7442C42.7034 61.2721 41.498 59.5141 41.7386 57.6408C41.9792 55.7674 43.5907 54.3633 45.5 54.3633C47.4094 54.3633 49.0209 55.7674 49.2615 57.6408C49.5021 59.5141 48.2967 61.2721 46.4479 61.7442Z",
    fill: "#009FDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock96);
export default __webpack_public_path__ + "static/media/padlock_96.3e41c6d4b2b9cb1442239c8d27d809bb.svg";
export { ForwardRef as ReactComponent };